<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import BookingCommentsForm from '~src/components/booking/forms/bookingCommentsForm.src'

    @Component({mixins: [BookingCommentsForm]})
    export class HotelCommentsForm extends Vue {
        @Prop() index

        get comment() {
            return this.productStore.prepareBookRequest[this.index]
                ? this.productStore.prepareBookRequest[this.index].comments
                : null
        }

        set comment(val) {
            this.productStore.SET_PREPARE_BOOK_REQUEST_PROP({prop: 'comments', val, index: this.index})
        }
    }

    export default {...toNative(HotelCommentsForm), ssrRender: BookingCommentsForm.ssrRender}
</script>
